// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clients-number-modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  .select-clients {
    width: 30%;
    height: 40px;
    border: 2px solid var(--dark-blue);
    border-radius: 5px;
    padding: 5px;
    font-size: 16px;
    background: rgba(0, 0, 0, 0.2);
    cursor: pointer;
    font-weight: bold;
  }
  .select-clients option {
    background: var(--dark-blue);
    color: white;
    font-size: 16px;
    cursor: pointer;
    color: white;
  }
  .select-clients:focus {
    outline: none;
  }
  .button-for-names {
    width: 200px;
    border: none;
    border-radius: 5px;
    background-color: var(--light-blue);
    color: var(--dark-blue);
    font-size: 13px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.3s;
    padding: 5px 8px;
  }
  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    width: 100%;
    animation: fadeIn 0.3s;
  }
  .labels {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
    width: 100%;
  }
  input {
    width: 90%;
    border: 2px solid var(--dark-blue);
    border-radius: 5px;
    padding: 5px;
    font-size: 16px;
    background: rgba(0, 0, 0, 0.2);
    color: var(--dark-blue);
    font-family: Poppins;
  }
  input:focus {
    outline: none;
  }
}


@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/ClientsNumberModal/ClientsNumberModal.css"],"names":[],"mappings":"AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;EACnB;IACE,UAAU;IACV,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;IACnC,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,uBAAuB;IACvB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;AACF;;;AAGA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["@import url('/src/App.css');\n.clients-number-modal {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  width: 100%;\n  height: fit-content;\n  .select-clients {\n    width: 30%;\n    height: 40px;\n    border: 2px solid var(--dark-blue);\n    border-radius: 5px;\n    padding: 5px;\n    font-size: 16px;\n    background: rgba(0, 0, 0, 0.2);\n    cursor: pointer;\n    font-weight: bold;\n  }\n  .select-clients option {\n    background: var(--dark-blue);\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n    color: white;\n  }\n  .select-clients:focus {\n    outline: none;\n  }\n  .button-for-names {\n    width: 200px;\n    border: none;\n    border-radius: 5px;\n    background-color: var(--light-blue);\n    color: var(--dark-blue);\n    font-size: 13px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: 0.3s;\n    padding: 5px 8px;\n  }\n  form {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    animation: fadeIn 0.3s;\n  }\n  .labels {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 6px;\n    width: 100%;\n  }\n  input {\n    width: 90%;\n    border: 2px solid var(--dark-blue);\n    border-radius: 5px;\n    padding: 5px;\n    font-size: 16px;\n    background: rgba(0, 0, 0, 0.2);\n    color: var(--dark-blue);\n    font-family: Poppins;\n  }\n  input:focus {\n    outline: none;\n  }\n}\n\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
